import { render } from "./EmailTemplates.vue?vue&type=template&id=471ea714&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"

import "./EmailTemplates.vue?vue&type=style&index=0&id=471ea714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471ea714"]])

export default __exports__